import * as React from 'react';

import { TranslationNode } from 'shared/entities/localization';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';

import Typography from '../Typography';

import './Label.modules.scss';

type Props = {
  children?: TranslationNode;
  className?: string;
  fontSize?: TypographySize;
};

const Label: React.FC<Props> = ({
  className,
  fontSize = TypographySize.m,
  children = (t) => t('withLabel.new', { ns: 'components' })
}: Props) => {
  return (
    <Typography
      fontType={TypographyType.text}
      fontSize={fontSize}
      fontWeight={TypographyWeight.heavy}
      fontColor={TypographyColor.white}
      styleName="label"
      className={className}
    >
      {children}
    </Typography>
  );
};

export default Label;
